// extracted by mini-css-extract-plugin
export var content = "_on-1";
export var fullScreen = "_on-0";